import { I1ElectricalChargingStation } from '@e3dc-react/icons'
import { OptionalTooltipWrapper } from '@e3dc-react/shell/Elements/Tooltip'
import React from 'react'

interface Props {
  hasWallbox?: boolean
  hasError?: boolean
}

const WallboxStatusIcon: React.FC<Props> = ({ hasWallbox = false, hasError = false }) => {
  const tooltipText = hasError ? 'installation-status.wallbox.tooltip-error' : 'installation-status.wallbox.tooltip-ok'

  if (hasWallbox) {
    return (
      <OptionalTooltipWrapper titleKey={tooltipText}>
        <I1ElectricalChargingStation color={hasError ? 'error' : 'inherit'} />
      </OptionalTooltipWrapper>
    )
  }

  return null
}

export default WallboxStatusIcon
